import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

import DefaultLayout from "/home/runner/work/documentation/documentation/node_modules/gatsby-theme-doctornpm/src/components/layout.js";
import shared from '../../../src/shared.js';
export const _frontmatter = {};

const makeShortcode = name => function MDXDefaultShortcode(props) {
  console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope");
  return <div {...props} />;
};

const Note = makeShortcode("Note");
const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">



    <p>{`As an organization member, you can configure your npm client to:`}</p>
    <ul>
      <li parentName="ul">{`make a single package or all new packages you create locally use your organization's scope`}</li>
      <li parentName="ul">{`make a single package or all new packages you create locally have default public visibility`}</li>
    </ul>
    <p>{`Before configuring your npm client, you must `}<a parentName="p" {...{
        "href": "downloading-and-installing-node-js-and-npm"
      }}>{`install npm`}</a>{`.`}</p>
    <h2>{`Configuring your npm client to use your organization's scope`}</h2>
    <p>{`If you will be publishing packages with your organization's scope often, you can add your organization's scope to your global `}<inlineCode parentName="p">{`.npmrc`}</inlineCode>{` configuration file.`}</p>
    <h3>{`Setting your organization scope for all new packages`}</h3>
    <Note mdxType="Note">
      <p><strong parentName="p">{`Note:`}</strong>{` Setting the organization scope using the steps below will only set the scope for new packages; for existing packages, you will need to update the `}<inlineCode parentName="p">{`name`}</inlineCode>{` field in `}<inlineCode parentName="p">{`package.json`}</inlineCode>{`.`}</p>
    </Note>
    <p>{`On the command line, run the following command, replacing `}{`<`}{`org-name`}{`>`}{` with the name of your organization:`}</p>
    <pre><code parentName="pre" {...{}}>{`npm config set scope <org-name> --global
`}</code></pre>
    <p>{`For packages you do not want to publish with your organization's scope, you must manually edit the package's `}<inlineCode parentName="p">{`package.json`}</inlineCode>{` to remove the organization scope from the `}<inlineCode parentName="p">{`name`}</inlineCode>{` field.`}</p>
    <h3>{`Setting your organization scope for a single package`}</h3>
    <ol>
      <li parentName="ol">
        <p parentName="li">{`On the command line, navigate to the package directory.`}</p>
        <pre parentName="li"><code parentName="pre" {...{}}>{`cd /path/to/package
`}</code></pre>
      </li>
      <li parentName="ol">
        <p parentName="li">{`Run the following command, replacing `}{`<`}{`org-name`}{`>`}{` with the name of your organization:`}</p>
        <pre parentName="li"><code parentName="pre" {...{}}>{`npm config set scope <org-name>
`}</code></pre>
      </li>
    </ol>
    <h2>{`Changing default package visibility to public`}</h2>
    <p>{`By default, publishing a scoped package with `}<inlineCode parentName="p">{`npm publish`}</inlineCode>{` will publish the package as private. If you are a member of an organization on the free organization plan, or are on the paid organization plan but want to publish a scoped package as public, you must pass the `}<inlineCode parentName="p">{`--access public`}</inlineCode>{` flag:`}</p>
    <pre><code parentName="pre" {...{}}>{`npm publish --access public
`}</code></pre>
    <h3>{`Setting package visibility to public for a single package`}</h3>
    <p>{`You can set a single package to pass `}<inlineCode parentName="p">{`--access public `}</inlineCode>{` to every `}<inlineCode parentName="p">{`npm publish`}</inlineCode>{` command that you issue for that package.`}</p>
    <ol>
      <li parentName="ol">
        <p parentName="li">{`On the command line, navigate to the package directory.`}</p>
        <pre parentName="li"><code parentName="pre" {...{}}>{`cd /path/to/package

`}</code></pre>
      </li>
      <li parentName="ol">
        <p parentName="li">{`Run the following command:`}</p>
        <pre parentName="li"><code parentName="pre" {...{}}>{`npm config set access public
`}</code></pre>
      </li>
    </ol>
    <h3>{`Setting package visibility to public for all packages`}</h3>
    <p>{`You can set all packages to pass `}<inlineCode parentName="p">{`--access public `}</inlineCode>{` to every `}<inlineCode parentName="p">{`npm publish`}</inlineCode>{` command that you issue for that package.`}</p>
    <Note mdxType="Note">
      <p><strong parentName="p">{`Warning:`}</strong>{` Setting packages access to `}<inlineCode parentName="p">{`public`}</inlineCode>{` in your global `}<inlineCode parentName="p">{`.npmrc`}</inlineCode>{` will affect all packages you create, including packages in your personal account scope, as well as packages scoped to your organization.`}</p>
    </Note>
    <p>{`On the command line, run the following command:`}</p>
    <pre><code parentName="pre" {...{}}>{`npm config set access public --global
`}</code></pre>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      